import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import { Container, Typography } from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PrincipalContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "OFF",
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Principal's Message" />

        <Container className="mb-5">
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                 

                  <div>
                    <div>
                      <Typography
                        variant="h5"
                        style={{ margin: "1em 0", fontWeight: 700 }}
                        gutterBottom
                      >
                        Principal's Message
                      </Typography>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        It gives me immense pleasure to welcome all of you to 
                        Rangia College, where education means all-round 
                        development of students. I thank you for your 
                        interest in this exceptional institution which 
                        has recorded more than five (05) decades of 
                        constant development, in course of which it 
                        has accomplished much, making it one (01) of the colleges 
                        recognised for its excellence and therefore, much sought 
                        after by the fresh applicants. While academic excellence 
                        is our major trust, the college is also devoted to prepare 
                        the students for life, groom them to face the challenges 
                        of tomorrow and encourage them to be socially relevant. 
                        
                      </Typography>
                      <br />

                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        Our mission is to inculcate the love of knowledge in our 
                        students and, for this, we aim to develop skills and demeanour 
                        of lifelong learning, essential for making responsible global 
                        citizens. On the deeper level, we try to instil the values of 
                        respect and trust in relationship that are the foundation of 
                        real success. I hereby solicit your cooperation and support 
                        in our endeavour to bring out the best and enable the 
                        students to become competent, confident, independent, 
                        creative and successful good citizens, with virtues of head, 
                        heart and character.
                      </Typography>
                      <br />
                      
                     
                      <div>
                        <div style={{ textAlign: "right" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "250px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div>

                        <h5
                          style={{
                            fontSize: "16px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}
                        </h5>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded &&
                              this.state.id != undefined && (
                                <a
                                  style={{
                                    color: "#1892FF",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    textAlign: "right",
                                  }}
                                  // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                  href={el.cv.length > 0 ? el.cv[0] : ""}
                                >
                                  Visit Profile
                                </a>
                              )}
                          </a>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Container>
      </div>
    );
  }
}
